import axios from "axios";

const API = axios.create({
  baseURL: "https://homefoods-backend-production.up.railway.app/api",
});

// ==============================
// Attach JWT Token
// ==============================

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// ==============================
// Business Profile
// ==============================

export const getBusinessProfile = async () => {
  const res = await API.get("/business/profile");
  return res.data;
};

export const updateBusinessProfile = async (data) => {
  const res = await API.put("/business/profile", data);
  return res.data;
};

// ==============================
// Business Hours
// ==============================

export const updateBusinessHours = async (data) => {
  const res = await API.put("/business/hours", data);
  return res.data;
};

// ==============================
// Address
// ==============================

export const getBusinessAddress = async () => {
  const res = await API.get("/business/address");
  return res.data;
};

export const updateBusinessAddress = async (data) => {
  const res = await API.put("/business/address", data);
  return res.data;
};

// ==============================
// Bank
// ==============================

export const getBankDetails = async () => {
  const res = await API.get("/business/bank");
  return res.data;
};

export const updateBankDetails = async (data) => {
  const res = await API.put("/business/bank", data);
  return res.data;
};

// ==============================
// Wallet
// ==============================

export const getWallet = async () => {
  const res = await API.get("/business/wallet");
  return res.data;
};

// ==============================
// Status
// ==============================

export const updateBusinessStatus = async (data) => {
  const res = await API.put("/business/status", data);
  return res.data;
};

// ==============================
// Photos
// ==============================

export const updateBusinessPhotos = async (formData) => {
  const res = await API.put("/business/photos", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

// ==============================
// Documents
// ==============================

export const updateBusinessDocuments = async (formData) => {
  const res = await API.put("/business/documents", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export default API;